import React from 'react';
import { Card, Col, Form, Row, Button } from 'react-bootstrap';

const PaginacionFooter = ({
    totalRegistros,
    pagina,
    tamanioPagina,
    totalPaginas,
    busqueda,
    handleCambiarTamanio,
    handlePaginaAnterior,
    handlePaginaSiguiente
}) => {
    return (
        <Card.Footer className="bg-white py-2">
            <Row className="align-items-center justify-content-between g-2">
                <Col xs="auto">
                    <span className="fs--1 text-600">
                        Mostrando {totalRegistros > 0 ? ((pagina - 1) * tamanioPagina) + 1 : 0} a {Math.min(pagina * tamanioPagina, totalRegistros)} de <strong>{totalRegistros}</strong> licencias {busqueda ? 'encontradas' : 'candidatas'}
                    </span>
                </Col>
                <Col xs="auto" className="d-flex align-items-center gap-2">
                    <Form.Select
                        size="sm"
                        style={{ width: 'auto' }}
                        value={tamanioPagina}
                        onChange={handleCambiarTamanio}
                    >
                        <option value={10}>10 por pág.</option>
                        <option value={15}>15 por pág.</option>
                        <option value={25}>25 por pág.</option>
                        <option value={50}>50 por pág.</option>
                        <option value={100}>100 por pág.</option>
                    </Form.Select>
                    <div className="d-flex align-items-center gap-1">
                        <Button
                            variant="falcon-default"
                            size="sm"
                            onClick={handlePaginaAnterior}
                            disabled={pagina <= 1}
                        >
                            Anterior
                        </Button>
                        <span className="fs--1 px-2 text-700">
                            {pagina} de {totalPaginas}
                        </span>
                        <Button
                            variant="falcon-default"
                            size="sm"
                            onClick={handlePaginaSiguiente}
                            disabled={pagina >= totalPaginas}
                        >
                            Siguiente
                        </Button>
                    </div>
                </Col>
            </Row>
        </Card.Footer>
    );
};

export default PaginacionFooter;
